var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-pdf"},[_c('form',{ref:"pdfForm",attrs:{"action":'/api/public/pdf/' + _vm.uuid + '?m=' + _vm.model,"method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"uuid"},domProps:{"value":_vm.uuid}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"model"},domProps:{"value":_vm.model}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17278105","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublicPdf.vue
// module id = 1743
// module chunks = 1